/**
 * 开局表单的 store。刻意与 `settingsStore` 分开：这是**一次性**的开局参数，
 * 不该持久化到 localStorage —— 上一局四个人的昵称留到下一局往往是错的。
 *
 * 之所以要 store 而不是组件内 useState：`Lobby`（stage 区）和 `LobbyDock`（dock 区）
 * 是 App 的两个平行 slot，DOM 上不是父子关系，没法靠 props 共享表单状态。
 */
import { create } from 'zustand'
import type { Chips } from '@poker/shared'

import {
  DEFAULT_LOCAL_SETUP_FORM,
  setBlinds,
  setName,
  setSeatCount,
  setStartingStack,
  type LocalSetupForm,
} from './localSetup.js'

export interface LobbyStore {
  readonly form: LocalSetupForm
  setSeatCount(n: number): void
  setName(seat: number, raw: string): void
  setBlinds(smallBlind: Chips, bigBlind: Chips): void
  setStartingStack(n: Chips): void
  reset(): void
}

export const useLobbyStore = create<LobbyStore>((set, get) => ({
  form: DEFAULT_LOCAL_SETUP_FORM,
  setSeatCount: (n) => set({ form: setSeatCount(get().form, n) }),
  setName: (seat, raw) => set({ form: setName(get().form, seat, raw) }),
  setBlinds: (sb, bb) => set({ form: setBlinds(get().form, sb, bb) }),
  setStartingStack: (n) => set({ form: setStartingStack(get().form, n) }),
  reset: () => set({ form: DEFAULT_LOCAL_SETUP_FORM }),
}))
